import showAdapter from './show'

export { showAdapter }



// WEBPACK FOOTER //
// ./shared/util/element/adapters/index.js